export let TrailerGenerationErrorType;
(function (TrailerGenerationErrorType) {
  TrailerGenerationErrorType["InternalError"] = "internal_error";
  TrailerGenerationErrorType["ConnectivityIssue"] = "connectivity_issue";
})(TrailerGenerationErrorType || (TrailerGenerationErrorType = {}));
//# sourceMappingURL=trailer-generation-statuses.js.map